

nsr.factory('Admin', ['$http', 'ErrorHandler', 'LoginService', function ($http, ErrorHandler, LoginService) {

    var basePath = 'operator-panel/';

    function makeRequest(verb, uri, data, withFile = false) {

        verb = verb.toLowerCase();

        //start with the uri
        var httpArgs = (isAbsolute(uri)) ? [uri] : [basePath + uri];
        if (verb.match(/post|put/)) {

            httpArgs.push(data);

            if (withFile) {
                httpArgs.push({headers: {'Content-Type': undefined}})
            }
        }

        var defer = $http[verb].apply(null, httpArgs);

        defer.error(function (data, status) {
            if(status == 401) {
                bootbox.alert("The requested resource requires authentication", function() {
                    LoginService.showLoginPage();
                });
            }
            else if(status == 403) {
                bootbox.alert("You do not have permission to access this resource.");
            }


            else if (status == 400 || status == 422) {  //400 means we are returning known error messages to be displayed

                var msg = '<ul>';
                _.each(data, function(error) {
                    console.log(error);
                   msg += '<li>' + error[0] + '</li>';
                });
                msg +='</ul>';


                ErrorHandler.setFieldErrors(data);

                bootbox.alert(msg);
            } else {
                console.log(data);
                bootbox.alert(data);
            }
        });

        //we might want to consider this to use some sort of time delay to make sure
        //we are not clearing errors to quickly in the case of multiple http requests close together
        defer.success(ErrorHandler.clearErrors);

        return defer;

    }

    function isAbsolute(url) {
        if (!/^(f|ht)tps?:\/\//i.test(url)) {
            return false;
        }
        return true;
    }

    return {
        get: function (uri, data) {
            return makeRequest('get', uri, data);
        }
        , post: function (uri, data, withFile = false) {
            return makeRequest('post', uri, data, withFile);
        }
        , put: function (uri, data) {
            return makeRequest('put', uri, data);
        }
        , delete: function (uri, data) {
            return makeRequest('delete', uri, data);
        }
    };
}]);


nsr.factory('DataService', ['Admin', function (Admin) {
    var _data = {
        financial_organizations: [],
        vendors: []
    };

    return {

        init: function() {
            Admin.get('data').then(function(response) {
                _data = response.data;
                //console.log(this._data.financial_organizations);
            });
        },
        financialOrganizations : function() {
            return _data.financial_organizations;
        },
        vendors : function() {
            return _data.vendors;
        },
        roles: function() {
            return _data.roles;
        }
    };
}]);

nsr.filter('orderObjectBy', function() {
    return function(items, field, reverse) {
        var filtered = [];
        angular.forEach(items, function(item) {
            filtered.push(item);
        });
        filtered.sort(function(a, b) {
            if (a[field] > b[field])
                return 1;
            if (a[field] < b[field])
                return -1;
            return 0;
        });
        if (reverse)
            filtered.reverse();
        return filtered;
    };
});

nsr.config(['$stateProvider', '$authProvider', '$urlRouterProvider', function($stateProvider, $authProvider, $urlRouterProvider) {
    $stateProvider
        .state('admin', {
            url: "/admin",
            templateUrl: 'operator-panel/partials/landing.html',
            controller: 'AdminController'
        });

    $stateProvider
        .state('admin-users', {
            url: "/admin/users",
            templateUrl: 'operator-panel/partials/users.html',
            controller: 'AdminUserController'
        });

    $stateProvider
        .state('admin-invoices', {
            url: "/admin/invoices",
            templateUrl: 'operator-panel/partials/invoices.html',
            controller: 'AdminInvoiceController'
        });

    $stateProvider
        .state('admin-models', {
            url: "/admin/models",
            templateUrl: 'operator-panel/partials/users.html',
            controller: 'AdminUserController'
        });

    $stateProvider
        .state('admin-status', {
            url: "/admin/status",
            templateUrl: 'operator-panel/partials/users.html',
            controller: 'AdminUserController'
        });

    $stateProvider
        .state('admin-fully-managed', {
            url: "/admin/fully-managed",
            templateUrl: 'operator-panel/partials/fully-managed.html',
            controller: 'AdminAccountController'
        });


    $stateProvider
        .state('admin-manifest', {
            url: "/admin/manifest",
            templateUrl: 'operator-panel/partials/manifest.html',
            controller: 'AdminManifestController'
        });

    $stateProvider
        .state('admin-user-edit', {
            url: "/admin/user/{id}",
            templateUrl: 'operator-panel/partials/user-edit.html',
            controller: 'AdminUserController'
        });


    $stateProvider
        .state('nsrj-admin', {
            url: "/nsrj/{cmd}",
            template: '<div>NSRJ Admin Panel</div><div ng-bind-html="nsrjPanelContent"></div>',
            controller: 'NSRJController'
        });


    $stateProvider
        .state('filter-manager', {
            url: "/filter-manager/",
            templateUrl: 'operator-panel/partials/filter.html',
            controller: 'AdminFilterController'
        });    


    // Reports

    $stateProvider
        .state('report-aum', {
            url: "/report/aum",
            templateUrl: 'operator-panel/partials/report-aum.html',
            controller: 'AdminReportAumController'
        });

    $stateProvider
        .state('report-fees', {
            url: "/report/fees",
            templateUrl: 'operator-panel/partials/report-fees.html',
            controller: 'AdminReportFeeController'
        });

    $stateProvider
        .state('report-generic', {
            url: "/report/generic",
            templateUrl: 'operator-panel/partials/report-generic.html',
            controller: 'AdminReportGenericController'
        });

}]);

nsr.controller('AdminFilterController',['$scope', '$http', '$timeout', 'Admin', function($scope, $http, $timeout, Admin) {
    $scope.vendor = 1;
    $scope.type = 'multi';

    $scope.filter = {
        selected_groups: []
    };


    $scope.groupNames = [];

    $scope.allFilters = null;

    $scope.showFilter = function(vendor, type) {
        return (vendor == $scope.vendor) && (type == $scope.type);
    };

    $scope.regenerateLendingClub = function() {
        $http({
            method: 'POST',
            url : 'filter/regenerate',
            data : {
                vendor_id : 1
            }
        }).success(function(data) {

        }).error(function(data) {

        });
    };

    $scope.regenerateProsper = function() {
        $http({
            method: 'POST',
            url : 'filter/regenerate',
            data : {
                vendor_id : 2
            }
        }).success(function(data) {

        }).error(function(data) {

        });
    };

    $scope.editFilter = function(filter_id) {
        $scope.filter = $scope.allFilters[filter_id];

        $('#load-modal').modal('show');
    };

    $scope.createFilter = function() {
        $scope.filter = {
            vendor_id : angular.copy($scope.vendor),
            selected_groups: []
        };


        $('#load-modal').modal('show');
    };

    $scope.deleteFilter = function(filter_id) {
        bootbox.confirm("Delete filter?", function (r) {
            if(r) {
                $http({
                    method: 'POST',
                    url: 'filter/delete?id=' + filter_id
                }).success(function(data) {
                    bootbox.alert("Filter Deleted");
                });
            }
        });

    };


    $scope.saveFilter = function() {
        Admin.post('filters', $scope.filter).then(function(response) {
            bootbox.alert("Filter Saved");
            $('#load-modal').modal('hide');
        });
    };

    $scope.init = function() {

        Admin.post('filters/groups').then(function(response) {
            $scope.groups = response.data;

            _.each($scope.groups, function(group) {
                _.each(group, function(obj) {
                    if(!_.has($scope.groupNames, obj.vendor_id)) {
                        $scope.groupNames[obj.vendor_id] = [];
                    }

                    $scope.groupNames[Math.abs(obj.vendor_id)][obj.filter_group_name_id] = obj.name;
                });



            });
            console.log($scope.groupNames);
            global1 = response.data;
        });

        Admin.post('filters/lists').then(function(response) {
            $scope.allFilters = response.data;
        });

    };

    $scope.init();
    $scope.sortColumn='name';
    $scope.sortReverse=false;
}]);

var global1;

nsr.controller('AdminController',['$scope', '$http', '$timeout', 'Admin', function($scope, $http, $timeout, Admin) {

    $scope.quickReport = function(report) {
        Admin.get("quick-report/" + report).then(function(response) {
            var reportWindow =window.open();
            reportWindow.document.open();
            reportWindow.document.write(response.data);
            reportWindow.document.close();
        });
    }

}]);

nsr.controller('AdminReportAumController',['$scope', 'DataService', '$timeout', 'Admin', function($scope, DataService, $timeout, Admin) {
    DataService.init();
    $scope.searching  = false;

    $scope.financialOrganizations = DataService.financialOrganizations;
    $scope.vendors = DataService.vendors;

    $scope.filter = {};

    $scope.result = [];

    $scope.update = function() {
        $scope.searching = true;
        Admin.post('report/aum', $scope.filter).then(function(response) {
            $scope.result = response.data;
            $scope.searching = false;
        });
    };

    $scope.update();
}]);

nsr.controller('AdminReportFeeController',['$scope', 'DataService', '$timeout', 'Admin', function($scope, DataService, $timeout, Admin) {
    DataService.init();
    $scope.searching  = false;

    $scope.financialOrganizations = DataService.financialOrganizations;
    $scope.vendors = DataService.vendors;

    $scope.filter = {};



    $scope.result = [];

    $scope.update = function() {
        $scope.searching = true;
        Admin.post('report/fees', $scope.filter).then(function(response) {
            $scope.result = response.data;
            $scope.searching = false;
        });
    };

}]);


nsr.controller('AdminUserController',['$scope', '$http', '$timeout','Admin', '$auth', '$state', '$stateParams', 'DataService', 'UserService', 'TransitionService', function($scope, $http, $timeout, Admin, $auth, $state, $stateParams, DataService, UserService, TransitionService) {
    $scope.page = 1;
    $scope.search = {};

    $scope.user = {};
    $scope.role =  {};

    $scope.invoices = {};

    DataService.init();



    // Forms
    $scope.financialOrganizations = DataService.financialOrganizations;
    $scope.vendors = DataService.vendors;
    $scope.roles = DataService.roles;

    $scope.reset = function() {
        $scope.search = {};
        $scope.page = 1;
        $scope.doSearch();
    };


    $scope.doSearch = function() {
        Admin.get('users?page=' + $scope.page +'&' + $.param($scope.search)).then(function(response) {
            $scope.users = response.data;
        });
    };
    $scope.doSearch();



    $scope.loginAs = function(userId) {
        bootbox.confirm("This will end your current session and login you as the following investor, proceed?", function(r) {
            if (r) {
                Admin.get('login-as/' + userId).then(function(response) {
                    $auth.setToken(response.data.auth_token);
                    TransitionService.showToastUntilCompleted(UserService.initUser(), "Switching user...").then(function() {
                        $state.go('dashboard', {}, {reload: true});
                    });
                });
            }
        })
    };

    $scope.loadUser = function(userId) {
        Admin.get('users/' + userId).then(function(response) {
            $scope.user = response.data;
        }, function(response) {
            bootbox.alert("Failed to load user");
        });

        TransitionService.showToastUntilCompleted(Admin.get('invoices?page=' + $scope.page +'&user_id=' + userId).then(function(response) {
            $scope.invoices = response.data;
        }), "searching...");
    };

    if($stateParams.id) {
        $scope.loadUser($stateParams.id);
    }



    $scope.saveUser = function() {
        Admin.put('users/' + $scope.user.id, $scope.user ).then(function(response) {
            bootbox.alert("User Saved");
        });
    };

    $scope.addRole = function(roledId) {
        Admin.post('users/' + $scope.user.id + '/roles/' + $scope.user.role.id).then(function () {
            $scope.loadUser($scope.user.id);
        });
    };

    $scope.removeRole = function(role) {
        Admin.delete('users/' + $scope.user.id + '/roles/' + role.id).then(function () {
            $scope.loadUser($scope.user.id);
        });
    };


    /**
     * Copy/pasta, its horrible, but to small to make me want to break it out
     * @param invoiceId
     */
    $scope.markPaid = function(invoiceId) {
        bootbox.confirm("This will mark the invoice as paid, proceed?", function(r) {
            TransitionService.showToastUntilCompleted(Admin.post('invoices/mark-paid/' + invoiceId).then(function(response) {
                $scope.doSearch();
            }), "setting invoice status...");
        });
    };

}]);

nsr.controller('AdminInvoiceController',['$scope', '$http', '$timeout','Admin', '$auth', '$state', '$stateParams', '$location', 'TransitionService', function($scope, $http, $timeout, Admin, $auth, $state, $stateParams, $location, TransitionService) {
    $scope.page = 1;

    $scope.pagination = {
        page: 1
    };

    $scope.invoices = {};
    $scope.showDetails = false;

    $scope.reset = function() {
        $scope.search = {};
        $scope.pagination.page = 1;
        $scope.doSearch();
    };

    // custodial accounts


    $scope.doSearch = function() {

        TransitionService.showToastUntilCompleted(
            Admin.get('invoices?page=' + $scope.pagination.page +'&' + $.param($scope.search)).then(function(response) {
            $scope.invoices = response.data;
        })
      , "searching...");
    };

    //run any queries that might be passed in (i.e. user page can link to the user's invoices)

    $scope.search = $location.search();

    if ($scope.search == null) {
        $scope.search = {};
    }

    if ($scope.search['page'] != null) {
        delete $scope.search['page'];
    }

    $scope.doSearch();


    $scope.markPaid = function(invoiceId) {
        bootbox.confirm("This will mark the invoice as paid, proceed?", function(r) {
            if(r) {
                TransitionService.showToastUntilCompleted(Admin.post('invoices/mark-paid/' + invoiceId).then(function (response) {
                    $scope.doSearch();
                }), "setting invoice status...");
            }
        });
    };

    $scope.markVoided = function(invoiceId) {
        bootbox.confirm("This will mark the invoice as voided, proceed?", function(r) {
            if(r) {
                TransitionService.showToastUntilCompleted(Admin.post('invoices/mark-voided/' + invoiceId).then(function (response) {
                    $scope.doSearch();
                }), "setting invoice status...");
            }
        });
    };

}]);


nsr.controller('AdminAccountController',['$scope', '$http', '$timeout','Admin', '$auth', '$state', '$stateParams', function($scope, $http, $timeout, Admin, $auth, $state, $stateParams) {
    var settings = {};


    $scope.accounts = [];

    Admin.get('fully-managed').then(function(response) {
        settings = response.data.settings;
        $scope.accounts = response.data.accounts;
    });

    $scope.bidMultiplierDrift = function(a) {
        return Math.floor((a.last_balance.account_total / settings.diversification) / settings.bidAmount);
    };

    $scope.idleMultiplierDrift = function(a) {
        return Math.floor((a.last_balance.account_total / settings.diversification) / settings.bidAmount);
    };


    var flagStyle = {'color':'red'};
    var noStyle = {};
    $scope.flagColumn = function(testCondition) {
        return (testCondition)  ? flagStyle : noStyle;
    };

}]);

nsr.controller('AdminManifestController',['$scope', '$stateParams','Admin', function($scope, $stateParams, Admin) {
    $scope.manifest = [];

    $scope.search = {};

    $scope.doSearch = function() {
        Admin.get('manifest?'+  jQuery.param($scope.search)).then(function(response) {
            $scope.manifest = response.data;
        });
    };

    $scope.doSearch();


}]);


nsr.controller('NSRJController',['$scope', '$stateParams','Admin', '$sce',function($scope, $stateParams, Admin, $sce) {

    $scope.nsrjPanelContent = 'Loading...';

    var cmd = 'nsrj';
    if ($stateParams.cmd != null && $stateParams.cmd != '') cmd = cmd + '?cmd=' + $stateParams.cmd;
    Admin.get(cmd).then(function(response) {
        var html = response.data.split('href="?cmd=').join('href="?operator=true#!/nsrj/');
        $scope.nsrjPanelContent = $sce.trustAsHtml(html);
    });


}]);


nsr.controller('AdminReportGenericController',['$scope', 'DataService', '$timeout', 'Admin', function($scope, DataService, $timeout, Admin) {
    $scope.searching  = false;

    $scope.header = [];
    $scope.results = [];
    $scope.filter = {};

    $scope.update = function(reportId) {
        $scope.searching = true;
        Admin.post('report/generic/' + reportId, $scope.filter).then(function(response) {
            $scope.header = response.data.header;
            $scope.results = response.data.results;
            $scope.searching = false;
        });
    };
}]);